<template>
  <el-dialog title="新增" :visible.sync="dialogVisible" width="800px" :destroy-on-close="true" @close="handleClose">
    <el-form :inline="false" :model="formData" :rules="rules" label-width="70px">
      <el-form-item label="排序">
        <el-input v-model.number="formData.sort" placeholder="请输入条件名称"></el-input>
      </el-form-item>
      <el-form-item label="取消原因">
        <el-input v-model="formData.title" placeholder="请输入条件名称"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-switch v-model="type" active-color="#13ce66"></el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitData">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addRule, getRuleInfo } from '@/api/set.js';
export default {
  data() {
    return {
      type: false,
      rules: {},
      formData: {
        type: 5,
        sort: 1,
        title: '',
        display: 2
      },
      dialogVisible: false
    };
  },
  watch: {
    type() {
      if (this.type) {
        this.formData.display = 1;
      } else {
        this.formData.display = 2;
      }
    }
  },
  methods: {
    init(id) {
      this.dialogVisible = true;
      if (id) {
        getRuleInfo({ id }).then((res) => {
          if (res.code == 1) {
            Object.assign(this.formData, res.data);
            this.type = res.data.display == 1 ? true : false;
          }
        });
      }
    },
    handleClose() {
      this.$emit('callBack');
    },
    submitData() {
      addRule(this.formData).then((res) => {
        if (res.code == 1) {
          this.$baseMessage(res.msg, 'success');
          this.dialogVisible = false;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped></style>